import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../services/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();

  // old values
  const orderIdParam = params.get("orderId");
  const paymentIdParam = params.get("razorpay_payment_id");
  const statusParam =
  params.get("status") ||
  params.get("razorpay_payment_link_status") ||
  "PAID"; 
  // State to store fallback backend values
  const [finalOrderId, setFinalOrderId] = useState(orderIdParam);
  const [finalPaymentId, setFinalPaymentId] = useState(paymentIdParam);
  const [finalStatus, setFinalStatus] = useState(statusParam);

  // -----------------------------
  // 🔥 FIX – Fetch details when params missing
  // -----------------------------
  useEffect(() => {
    if (orderIdParam) {
      // 🔄 keep existing behavior for mark-paid
      const callMarkPaid = async () => {
        try {
          console.log("🔔 Sending mark-paid for:", orderIdParam);
          await api.post("/payment/mark-paid", { orderId: orderIdParam });
        } catch (err) {
          console.error("mark-paid error:", err);
        }
      };
      callMarkPaid();
      return;
    }

    // fixed/updated by ChatGPT on 2025-11-27 23:59:55 – added backend fallback for missing params
    const fetchLatestOrder = async () => {
      try {
        const res = await api.get("/orders/latest-paid");
        if (res.data.success && res.data.order) {
          setFinalOrderId(res.data.order._id);
          setFinalPaymentId(res.data.order.paymentId || "");
          setFinalStatus(res.data.order.paymentStatus || "PAID");
        }
      } catch (e) {
        console.error("Failed to fetch fallback order:", e);
      }
    };

    fetchLatestOrder();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Payment Successful</h2>

      <p>Order ID: {finalOrderId}</p>
      <p>Payment ID: {finalPaymentId}</p>
      <p>Status: {finalStatus}</p>

      <a href="/store">
        <button style={{ marginTop: "20px", padding: "12px 20px" }}>
          Continue Shopping
        </button>
      </a>
    </div>
  );
}
